<template>
  <div>
      <div id="box">
        <v-row >
          <v-col cols="12" class="pd-bottom-0">
            <v-row justify="center" align="center">
              <v-col>
                <div id="title" :style="{'color':theme}">                  
                  {{title}}
                </div>
              </v-col>
              <v-col justify="center" align="center" >
                <div style="padding:10px 10px 0px 10px;">
                  <v-select
                    v-model="selectedFilter"
                    item-value="id" 
                    item-text="name"
                    :items="filters"
                    label="Filter"
                    dense
                    hide-details
                    outlined
                    @change="selectedChangeHandler"
                  ></v-select>
                </div>
              </v-col>
            </v-row>  
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="mg-top-0">
            <v-col cols="12" class="pd-top-0">
                <v-container class="pd-top-0">
                    <v-row>
                      <v-col v-for="(item, index) in previews.avgBlocks" :key="index">
                        <div id="avgbox">
                          <div id="avg">{{ item.avg }}</div>
                          <div id="avgTitle">{{ item.title }}</div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-simple-table fixed-header>
                        <template v-slot:default>
                        <thead>
                            <tr>
                              <th style="border:none !important;" v-for="(field, index) in fields" :key="index" class="text-center">
                                  {{field.header}}
                              </th>                            
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="(item, index) in previews.items"
                            :key="index" 
                            >
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" v-for="(field, index) in fields" :key="index" align="center">
                                <div v-if="index === 0" class="left-div-border" :style="{ 'border-left-color': theme }"></div>
                                <div v-if="field.format[0] ==='multiple'">{{ item[field.name[0]] }}/{{ item[field.name[1]] }}
                                    <span style="font-size:10px;">{{ field.format[1] }}</span>
                                </div>
                                <div v-else>
                                    <div v-if="field.type === 'money'">
                                        {{ item[field.name] }}
                                        <span style="font-size:10px;">{{ field.format[1] }}</span>
                                    </div>
                                    <div v-else>{{ item[field.name] }}</div>
                                </div>
                              </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>                    
                </v-container>
            </v-col>
        </v-row>
        <v-divider class="mg-top-0" ></v-divider>
        <v-row justify="space-around" align="center" >
          <v-col cols="12" align="right">
            <v-btn text class="ma-2" :color="theme" @click="seeMoreModalOpen">See More...</v-btn>
          </v-col>
        </v-row>
      </div>         
      <see-more :dialog="seeMoreDialog" 
      :title="title" 
      :closeDialog="seeMoreModalClose" 
      :headers="fields" 
      :DataItems="detail.items"  
      :theme="theme"
      :filterItems="filters"
      :filterCampaigns="filterCampaigns"
      :avgArray="detail.avgBlocks"
      :key="seeMoreDialogKey"
      :type="type"
      @searchFilter="seeMoreFilter"/>  
  </div>
</template>
<script>
import seeMore from '../DashboardComponents/SeeMoreModal.vue'
export default {
  name: 'CampaignsActivities',
  components: {
    seeMore
  },
  props: {
    title: {type: String},
    theme: {type: String},
    previews: {type: Object},
    detail: {type: Object},
    fields: {type: Array},
    filters: {type: Array},
    filterCampaigns: {type: Array},
    type: {type: String}
  },
  data: () => ({
    selectedFilter: '',
    itemArray: [],
    seeMoreDialog: false,
    seeMoreDialogKey: 0
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    selectedChangeHandler() {
      let filter = Object.assign({}, {
        CO: this.selectedFilter
      })
      this.$emit('searchFilter', {filter, type: this.type, filterSource: 'previews'})
    },
    seeMoreFilter(filters) {
      this.$emit('searchFilter', filters)
    },
    seeMoreModalOpen() {
      this.seeMoreDialog = true
    },
    seeMoreModalClose() {
      this.seeMoreDialog = false
      this.seeMoreDialogKey += 1
    }
  }
}
</script>
<style scoped>
.mg-top-0 {
  margin-top: 0px !important;
}

.mg-bottom-0 {
  margin-bottom: 0px !important;
}

.mg-bottom-10 {
  margin-bottom: 10px !important;
}

.pd-bottom-0 {
  padding-bottom: 0px !important;
}

.pd-top-0 {
  padding-top: 0px !important;
}

#box {
  /* width: 366px; */
  /* min-height: 430px; */

  border: 0.8px solid #E5E5E5;
  box-sizing: border-box;
}

#title {
  /* width: 366px; */
  height: 46px;

  font-family: WorkSans-Medium;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 45px;
  
  padding-left:17px;
  padding-top:5px;
}

#avgbox {
  /* width: 334px; */
  height: 71px;
  margin-bottom:20px;
  /* margin-left: 17px; */
  /* margin-top: 60px; */

  background: rgba(255, 255, 255, 0.0001);
  border: 1px solid #E5E5E5;
}

#avg {
  padding-top:10px;
  /* height: 28px; */
  left: calc(50% - 304px/2 - 1px);
  top: calc(50% - 28px/2 - 7.5px);

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

#avgTitle {
  /* width: 309px; */
  height: 12px;
  left: calc(50% - 309px/2 - 3.5px);
  top: calc(50% - 12px/2 + 18.5px);
  padding-top:5px;

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
/* identical to box height */

  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

.left-div-border {
  border-left: 4px solid;
  height: 35px;
  width: 4px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// CampaignsActivities.vue?7d47aa65